<template>
  <div class="emotion-node-analysis">
    <div class="search-area">
      <div class="toolbar-line">
        <span class="search-area-label">日期:</span>
        <el-date-picker
          class="search-area-select search-area-select--date"
          :size="isMini"
          v-model="date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </div>
    </div>
    <RelayEcologyPanel :selected-date="date" />
  </div>
</template>

<script>
import { formatDate } from '@/utils/index'
import { BREAKPOINTS } from '@/utils/device'
import RelayEcologyPanel from '@/views/GapUpAnalysis/components/RelayEcologyPanel.vue'

export default {
  name: 'EmotionNodeAnalysis',
  components: {
    RelayEcologyPanel
  },
  data() {
    return {
      isMobile: false,
      date: formatDate()
    }
  },
  computed: {
    isMini() {
      return this.isMobile ? 'mini' : ''
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= BREAKPOINTS.MOBILE
    }
  }
}
</script>

<style lang="scss" scoped>
.emotion-node-analysis {
  .search-area {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 8px;
  }

  .toolbar-line {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .search-area-label {
    margin-right: 10px;
    color: #606266;
  }

  .search-area-select--date {
    width: 150px;
  }
}
</style>
